module.exports = __webpack_public_path__ + "static/media/AppleIPhone.a99f9dc6.png";